// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__footer__2kABK"};


//////////////////
// WEBPACK FOOTER
// ./src/footer/footer.scss
// module id = 197
// module chunks = 0